import { memo } from 'react';

import { CalculationsSectionObserver } from './CalculationsSectionObserver';
import { IObservedFormsType, observedFields } from './utils/form';

export const CalculationsObserver = memo(() => {
  return (
    <>
      {Object.keys(observedFields).map((formName) => {
        const key = formName as IObservedFormsType;
        return (
          <CalculationsSectionObserver
            key={key}
            fieldNames={observedFields[key].observeValueChangeFieldNames}
            formName={key}
          />
        );
      })}
    </>
  );
});
